module.exports = __webpack_public_path__ + "img/search.624eb345.png";